import { Marker, Popup } from 'react-map-gl/mapbox';
import cannonIcon from '../../../assets/cannon-circle.png'; // Asegúrate de que la ruta sea correcta
import './CannonMarker.css';
import CoordinatesLink from '../Base/CoordinatesLink';
import { useMap } from 'react-map-gl/mapbox';

const CannonMarker = ({ cannon , isActive , onActivate , onDeactivate }) => {
  const { current: map } = useMap();
  return (
  <>
    <Marker 
      longitude={cannon.location.longitude} latitude={cannon.location.latitude}
      className={`cannon-marker ${cannon.status === 'activo' ? 'pulse-slow' : ''} ${cannon.sector === "1" ? 'cannon-sector-1' : cannon.sector === "2" ? 'cannon-sector-2' : ''}`} // Añade la clase "pulse" si el cañón está activo
      >
      <img
        onClick={(e) => {
            e.stopPropagation();
            map.easeTo({
                            center: [cannon.location.longitude, cannon.location.latitude],
                            offset: [0, -100], // desplaza el mapa hacia arriba
                            duration: 500,
                        });
            onActivate(); }} // Abre el popup al hacer clic
        src={cannonIcon}
        alt="Cannon"
        className="cannon-marker-image"
    />
    </Marker>
    {isActive && (
        <Popup
            longitude={cannon.location.longitude}
            latitude={cannon.location.latitude}
            onClose={onDeactivate}
            closeOnClick={true}
            anchor="top"
        >
          <div style={{ fontFamily: "'Inter', sans-serif", maxWidth: '200px', minWidth: '150px' }} >
            <h3 style={{ marginBottom: '4px', fontSize: '14px' }}>Cañón </h3>
            <span style={{ fontSize: '28px' }}>{cannon.name}</span>{cannon.sector && <><br /><span style={{fontSize: '18px'}}> Sector {cannon.sector}</span></>}
            <p>
                Estado: <strong>{cannon.status}</strong>
            </p>
            <CoordinatesLink latitude={cannon.location.latitude} longitude={cannon.location.longitude} />
          </div>
        </Popup>
    )}
  </>
)};

export default CannonMarker;